import type {
  CommandData,
  CommitmentCommandData,
} from '@festina/life-general-types/life'

import type { CommandDataRecord } from '../types'
import { commitmentCommands } from './commitmentCommands'
import { employerAgreementCommands } from './employerAgreementCommands'
import { pretendCommands } from './pretendCommands'

export const lifeCommands: CommandDataRecord<CommandData['_type']> = {
  AnnotationCommandData: () => null,
  ...employerAgreementCommands,
  ...pretendCommands,
  ...(commitmentCommands as CommandDataRecord<CommitmentCommandData['_type']>),
}
